import * as Sentry from "@sentry/browser";

let initialized = false;

export function initMonitoring(): void {
  const dsn = process.env.GATSBY_SENTRY_DSN;
  if (!dsn || initialized) return;
  Sentry.init({
    dsn,
    environment: process.env.GATSBY_NODE_ENV || process.env.NODE_ENV || "production",
  });
  initialized = true;
}

export function captureMonitoringError(error: unknown, context: Record<string, unknown> = {}): void {
  if (process.env.GATSBY_SENTRY_DSN) {
    initMonitoring();
    Sentry.captureException(error, { extra: context });
  }
}
